<template>
  <div :class="$style['card-content']">
    <scrollable-content :contentList="recordData.cards">
      <no-ssr v-if="!isCommercial && isAdvPlace(index)" slot="adv" slot-scope="{index}">
        <component
          v-if="getInreadBlock(getAdvIndex(index))"
          v-bind="bindAdvComponent"
          :adv="getInreadBlock(getAdvIndex(index))"
          :index="isRepeatBlock(getAdvIndex(index)) ? index : undefined"
          :clientRender="true"
        />
      </no-ssr>
    </scrollable-content>
  </div>
</template>

<script>
  import NoSSR from 'vue-no-ssr';
  import { guardUnspecified } from '@portal/utils/util-guards';

  import { StoreMixin } from '../../../shared/mixins/store';
  import { AdvInread, AdvCreative } from '../../../shared/components/_adv';

  import { ScrollableContent } from '../components/scrollable-content';

  export default {
    name: 'CardsContent',
    components: {
      AdvInread,
      AdvCreative,
      ScrollableContent,
      'no-ssr': NoSSR
    },
    mixins: [StoreMixin],
    computed: {
      isMobile() {
        return this.store.deviceInfo.isMobile;
      },
      recordBlock() {
        return this.store.layoutModule.record;
      },
      recordData() {
        return this.recordBlock?.data ?? {};
      },
      isCommercial() {
        return this.recordData.isCommercial;
      },
      isScroogeTest() {
        return this.store.layoutModule.isScroogeTest;
      },
      bindAdvComponent() {
        return {
          is: this.isScroogeTest ? 'AdvCreative' : 'AdvInread'
        };
      }
    },
    methods: {
      isAdvPlace(index) {
        //Расстановка инридов через N карточек начиная со второй
        return (index - 1) % 5 === 0;
      },
      getAdvIndex(index) {
        //Math.ceil() нужен для получения индекса следующего по очереди инрида при вставке по условию isLastAdvPlace
        return Math.ceil(((index - 1) / 5) + 1);
      },
      getInreadBlock(advIndex) {
        //Когда блоки закончились вставляем самый последний каждый раз
        if (this.isRepeatBlock(advIndex)) {
          return this.getRepeatAdvBlock();
        }

        return this.getAdvBlock(advIndex);
      },
      getAdvBlock(advIndex) {
        const suffix = advIndex === 1 ? '' : advIndex;
        const advBlockName = this.isMobile ? 'mobileRecordInreadAdvert' + suffix : 'desktopRecordInreadAdvert' + suffix;

        return this.store.advModule[advBlockName];
      },
      isRepeatBlock(advIndex) {
        return !guardUnspecified(this.getAdvBlock(advIndex));
      },
      getRepeatAdvBlock() {
        const repeatedAdvBlockName = this.isMobile ? 'mobileRecordInreadAdvert6' : 'desktopRecordInreadAdvert3';
        return this.store.advModule[repeatedAdvBlockName];
      }
    }
  };
</script>

<style lang="scss" module>
  @import 'styles';

  .card-wrapper {
    display: flex;
    flex-direction: column;
  }

  .card-content {
    display: flex;
    flex-direction: column;

    @include on-res($mobile) {
      padding-top: $mobile-padding;
    }
  }
</style>
